'use strict'

module.exports = (function () {

    /**
    * @doc method
    * @name initializePicker
    * @description Initialize a month year picker
    **/

    /// ***********************************************************************
    /// options include
    ///     elementId: css selector to element which should be initialized as the month/year picker
    ///     disabledOptions: enabled months (ex. {2023: [10, 11, 12], 2024: [5, 6, 9]}) - this comes from what departures are available
    ///     enablePastMonths: whether or not past months should be enabled/disabled (default disabled)
    ///     callback: function to call on month/year selected
    /// ***********************************************************************
    let initializePicker = function (options) {
        var monthYearEl = document.getElementById(options.elementId);
        if (!monthYearEl) {
            return;
        }

        let defaultOptions = {
            enabledOptions: {},
            enablePastMonths: false,
            appendHash: false
        }
        options = options || {};
        _.defaults(options, defaultOptions);

        var validOptions = initializePickerOptions(options);

        renderPicker(options.elementId, validOptions, options.appendHash);
    }

    let renderPicker = function (elementId, monthYearOptions, appendHash) {
        new Vue({
            el: '#' + elementId,
            data: {
                activeYear: new Date().getFullYear(),
                activeMonth: {},
                appendHash: appendHash || false,
                currentYear: new Date().getFullYear(),
                options: monthYearOptions,
                showCalendar: false,
                showNextYear: true,
                showPreviousYear: true,
                isOpen: false,
                windowWidth: window.innerWidth,
                id: elementId
            },
            computed: {
                years: function () {
                    return Object.keys(this.options).sort(function (a, b) {
                        return a - b;
                    });
                },
                nextAvailableMonth: function() {
                    var nextAvailableMonth = null;
                    if (this.options[this.activeYear] != null) {
                        nextAvailableMonth = _.find(this.options[this.activeYear], (month) => {
                            return month.enabled;
                        });
                    }

                    return nextAvailableMonth;
                },
            },
            created(){
                let minYear = this.getMinYear();
                let maxYear = this.getMaxYear();

                this.isMinYear(minYear);
                this.isMaxYear(maxYear);
            },
            mounted: function () {
                this.setDateFromQueryString();
                window.addEventListener('resize', this.updateWidth);
            },
            beforeDestroy: function(){
                window.removeEventListener('resize', this.updateWidth);
            },
            methods: {
                isActiveYear: function(year) {
                    return this.activeYear == year;
                },
                isActiveMonth: function (month) {
                    return this.activeMonth == month;
                },
                isActive: function (year, month) {
                    return this.isActiveYear(year) && this.isActiveMonth(month);
                },
                getMinYear: function () {
                    if (!this.years || this.years.length === 0) {
                        return;
                    }

                    return this.years[0];
                },
                getMaxYear: function () {
                    if (!this.years || this.years.length === 0) {
                        return;
                    }
                    return this.years[this.years.length - 1];
                },
                handleOutsideClick(event) {
                    if (!this.$refs.ysNav.contains(event.target)) {
                        this.closeCalendar();
                    }
                },
                isMaxYear: function (maxYear) {
                    if (this.activeYear == maxYear) {
                        this.showNextYear = false;
                    }
                    else {
                        this.showNextYear = true;
                    }
                },
                isMinYear: function (minYear) {
                    if (this.activeYear == minYear) {
                        this.showPreviousYear = false;
                    }
                    else {
                        this.showPreviousYear = true;
                    }
                },
                nextYear: function () {
                    var maxYear = this.getMaxYear();
                    var minYear = this.getMinYear();
                    if (this.activeYear < maxYear) {
                        this.activeYear++;

                        this.isMinYear(minYear);
                        this.isMaxYear(maxYear);
                    }
                },
                prevYear: function () {
                    var maxYear = this.getMaxYear();
                    var minYear = this.getMinYear();
                    if (this.activeYear > minYear) {
                        this.activeYear--;

                        this.isMinYear(minYear);
                        this.isMaxYear(maxYear);
                    }
                },
                toggleCalendar: function(year){
                    if (!this.showCalendar || year != this.activeYear) {
                        this.setActiveYear(year);
                        this.showCalendar = true;

                        var minYear = this.getMinYear();
                        var maxYear = this.getMaxYear();
                        this.isMinYear(minYear);
                        this.isMaxYear(maxYear);
                    }
                    else if (this.activeYear == year) {
                        this.showCalendar = false;
                    }
                },
                closeCalendar: function () {
                    this.showCalendar = false;
                },
                setActiveYear: function(year){
                    this.activeYear = year;
                },
                setDateFromQueryString: function () {
                    let queryParams = new URLSearchParams(window.location.search);
                    let dateParam = queryParams.get('m');
              
                    if (!dateParam) {
                        return;
                    }

                    let yearFromQueryString = parseInt(dateParam.substring(0, 4), 10);
                    let monthFromQueryString = parseInt(dateParam.slice(4, 6)) - 1;
                    let useOnlyYear = dateParam.substring(6);
                    if (!useOnlyYear) {
                        this.activeMonth = monthFromQueryString;
                    }
                    this.currentYear = yearFromQueryString;
                    this.activeYear = yearFromQueryString;
                },
                updateWidth: function() {
                    this.windowWidth = window.innerWidth;
                }
            },
            watch: {
                showCalendar: function(newValue) {
                    if (newValue) {
                        // Calendar is opened
                        document.addEventListener('click', this.handleOutsideClick);
                    } else {
                        // Calendar is closed
                        document.removeEventListener('click', this.handleOutsideClick);
                    }
                },
                windowWidth: function(newWidth) {
                    if(elementId == "departures-year-select") {
                        this.appendHash = true;
                    }
                    else {
                        this.appendHash = false;
                    }
                }
            }
        });
    }

    let initializePickerOptions = function (options) {
        var years = getYears(options.enabledOptions);
        var optionsDictionary = {};
        for (let i = 0; i < years.length; i++) {
            optionsDictionary[years[i]] = getMonths();
        }

        var currentDate = new Date();
        var currentYear = currentDate.getFullYear();
        var currentMonth = currentDate.getMonth();
        if (options.enablePastMonths && currentMonth > 0) {
            let pastMonths = _.range(currentMonth);
            if (!Object.hasOwn(options.enabledOptions, currentYear)) {
                options.enabledOptions[currentYear] = pastMonths;
            }
            else {
                options.enabledOptions[currentYear] = _.union(options.enabledOptions[currentYear], pastMonths);
            }
        }

        if (!options.enabledOptions || options.enabledOptions.length === 0) {
            return optionsDictionary;
        }

        var yearsWithEnabledMonths = Object.keys(options.enabledOptions);
        for (let i = 0; i < yearsWithEnabledMonths.length; i++) {
            let year = yearsWithEnabledMonths[i];
            if (!Object.hasOwn(optionsDictionary, year) || options.enabledOptions[year].length === 0) {
                continue;
            }

            // Trim out all options in the optionsDictionary that are present in the list of disabled options
            for (let j = 0; j < options.enabledOptions[year].length; j++) {
                var enabledMonthIdx = options.enabledOptions[year][j];
                if (optionsDictionary[year][enabledMonthIdx]) {
                    optionsDictionary[year][enabledMonthIdx].enabled = true;
                }
                
            }
        }

        return optionsDictionary;
    };

    let getYears = function (optionDictionary) {
        return Object.keys(optionDictionary).sort(function (a, b) {
            return a - b;
        });
    }

    let getMonths = function () {
        return [
            new monthYear(0, 'Jan'),
            new monthYear(1, 'Feb'),
            new monthYear(2, 'Mar'),
            new monthYear(3, 'Apr'),
            new monthYear(4, 'May'),
            new monthYear(5, 'Jun'),
            new monthYear(6, 'Jul'),
            new monthYear(7, 'Aug'),
            new monthYear(8, 'Sep'),
            new monthYear(9, 'Oct'),
            new monthYear(10, 'Nov'),
            new monthYear(11, 'Dec'),
        ];
    }

    // Month/Year option model
    let monthYear = function (monthIdx = 0, label) {
        this.month = monthIdx;
        this.displayMonth = getDisplayMonth(monthIdx);
        this.label = label;
        this.enabled = false
    }

    let getDisplayMonth = function (monthIdx) {
        let displayMonth = monthIdx + 1;
        return displayMonth.toString().padStart(2, '0');
    }

    // Return an object exposing the public items
    return {
        initialize: initializePicker,
        initializeOptions: initializePickerOptions
    };
}())